import * as yup from 'yup';
import i18n from 'i18n';

export const validationSchema = () => yup.object().shape({
  student: yup.string().required(i18n.t('common.error.required')),
  institution: yup.string().required(i18n.t('common.error.required')),
});
